jQuery(document).ready(function ($) {
    $navHeight = $('.main-header').outerHeight();
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - $navHeight + 80
        }, 500);
    });

    $('.menu-item-has-children').each(function (key, item) {
        let subMenuHeight = 0;

        if ($(item).find('.sub-menu').length) {
            subMenuHeight = $(item).find('.sub-menu').outerHeight();
        }

        if ($(item).find('.sub-menu-bg').length) {
            $(item).find('.sub-menu-bg').css('height', subMenuHeight + 40);
        }
    });

    $('.search-toggle').on('click', function () {
        $(this).addClass('search-toggle--hide');
        $('.header-search').toggleClass('header-search--active');

        setTimeout(function () {
            $('.search-form__field').focus();
        }, 100);
    });

    $('.search-form__close').on('click', function () {
        $('.header-search').toggleClass('header-search--active');
    });


    $('.checks .gchoice').on('click', function () {
        $(this).toggleClass('active');
    });

    $('.menu-item-has-children').hover(function () {
        $(this).toggleClass('sub-active');
        $('.menu-item').not(this).toggleClass('item-opacity');
    });

    if ($(window).width() < 1101) {

        $('.toggle-nav').on('click', function () {
            $(this).toggleClass('is-active');
            $('.nav--main').toggleClass('show');
            $('body').toggleClass('no-scroll');
        });

        $('.toggle-house-list').on('click', function () {
            $(this).toggleClass('is-active');
            $('.virtual-house__list').toggleClass('show');
        });

        $('.top-nav').appendTo('.nav-main');

        $('.menu-item-has-children > a').one("click", function (e) {
            e.preventDefault();
        });

        $('.footer-cols__item .heading').on('click', function () {
            $(this).parent().closest('ul').toggleClass('toggle');
        });
    }

    var $viewportMeta = $('meta[name="viewport"]');
    $('input, select, textarea').bind('focus blur', function (event) {
        $viewportMeta.attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
    });
});
